import MinMaxType from '../types/min-max.type';

export default function randomizeBetweenValues([min, max]: MinMaxType) {
  return Math.random() * (max - min) + min;
}
